import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var meta = {
  auth: ['admin']
};
export default [_objectSpread({
  path: "/system/menu",
  title: '菜单管理',
  icon: 'md-menu',
  header: 'system'
}, meta), _objectSpread({
  path: "/system/role",
  title: '角色管理',
  icon: 'ios-people',
  header: 'system'
}, meta), _objectSpread({
  path: "/system/user",
  title: '用户管理',
  icon: 'ios-person',
  header: 'system'
}, meta), _objectSpread({
  path: "/system/dict",
  title: '数据字典',
  icon: 'ios-options',
  header: 'system'
}, meta), _objectSpread({
  path: "/system/config",
  title: '系统配置',
  icon: 'ios-settings',
  header: 'system'
}, meta), _objectSpread({
  path: '/system/tenant',
  title: '租户管理',
  icon: 'md-walk',
  header: 'system'
}, meta),
// {
//     path: '/log',
//     title: '前端日志',
//     header: 'system',
//     icon: 'md-locate',
//     ...meta
// },
{
  path: '/setting/account',
  title: '个人设置',
  header: 'home'
}];